import React from "react";
import {
  DashboardCardContainer,
  DashboardCardStrip,
  DashboardCard,
  DashboardCardIconContainer,
  DashboardCardTextContainer,
  DashboardCardAmount,
  DashboardCardHeader,
  DashboardCardSubHeader
} from "./SquareDashboardCardStyles"; 

export default ({ heading, subHeading, amount, icon, colour }) => {
  return (
    <DashboardCardContainer>
      <DashboardCardStrip style={{ backgroundColor: `var(--${colour})` }} />
      <DashboardCard style={{ backgroundColor: `var(--${colour}Opaque)` }}>
        <DashboardCardIconContainer>{icon}</DashboardCardIconContainer>
        <DashboardCardTextContainer>
          <DashboardCardAmount>{amount}</DashboardCardAmount>
          <DashboardCardHeader>{heading}</DashboardCardHeader>
          <DashboardCardSubHeader>{subHeading}</DashboardCardSubHeader>
        </DashboardCardTextContainer>
      </DashboardCard>
    </DashboardCardContainer>
  );
};
